import { createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { setFloorplans } from "store/slices/floorplans.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncQueries = {
  getFloorplansByEquipmentId: createAppAsyncThunk(
    "floorplans/getFloorplansByEquipmentId",
    async (equipmentId: number, { rejectWithValue, extra: { sdk }, dispatch }) => {
      try {
        const { data, errors } = await graphqlRequest(() =>
            sdk.getFloorplans({ equipmentId })
            );

        if (errors || !data?.floorplans) {
          return rejectWithValue("Failed to fetch floorplans");
        }
        dispatch(setFloorplans(data.floorplans));
        return { floorplans: data.floorplans };
      } catch (error) {
        return rejectWithValue("Unexpected error occurred");
      }
    }
  ),
};
